import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { TASKS } from '@shared/api/endpoints';
import type { DiffResult } from '@tailorcast/shared-types';

export function useTaskDiffs(taskId: string | undefined) {
  return useQuery({
    queryKey: ['task', taskId, 'diffs'],
    queryFn: () => api.get<{ diffs: DiffResult[] }>(TASKS.DIFFS(taskId!)),
    enabled: !!taskId,
  });
}
